<template>
  <btn flat class="apple-integration integration-btn">
    <apple-icon class="icon" />
    <span v-if="login" v-t.preserve="'auth.apple.signIn'" />
    <span v-else v-t.preserve="'auth.apple.signUp'" />
  </btn>
</template>

<script>
export default {
  name: 'apple-integration-btn',
  props: {
    login: Boolean
  }
}
</script>

<style lang="scss" scoped>
button.btn.apple-integration {
  background: linear-gradient(180deg, #000000 0%, #453D4C 100%);
}
</style>
